export default `# Creating a Session

The session creator walks you through a 4-step setup to configure and launch a new live session.

---

## Step 1: Session Details

- **Session Name** (required) — What this session is called
- **Link to Project** (optional) — Attach the session to an existing project. This shares context between the project's knowledge base and the session's AI avatars.

---

## Step 2: Select Template

Choose a session template that defines the structure and phases:

- **Default template** — Pre-configured and recommended for most sessions
- **Other templates** — Shown as cards with category badge, version, and phase count
- **Custom Phases** — Skip templates entirely and pick phases manually

If you select a template, a preview section shows its phases and structure. An **Advanced Options** toggle lets you override the template's phases (not recommended unless you have specific needs).

---

## Step 3: Avatar Configuration

Choose which AI personas will participate:

| Mode | Description |
|------|-------------|
| Default Avatars | 7 pre-configured facilitator avatars — good for most sessions |
| Avatar Group | Select a pre-built group of avatars |
| Custom Selection | Search and hand-pick individual avatars |

In Custom mode, use the search box to find avatars. Selected avatars appear in a preview panel.

---

## Step 4: Workshop Goals

Define what you want to achieve:
- Add numbered goals that give the AI context about the session's purpose
- Click **+ Add Goal** for additional objectives
- Remove goals with the X button

Goals guide avatar behaviour — the more specific you are, the more relevant their contributions will be.

---

## Optional: Workshop Phases

If you chose "Custom Phases" or unchecked "use template phases":
- Toggle individual phases on/off from a list of standard options:
  - Intros, Challenge Deep Dive, Mini PR/FAQ, Persona Identification, User Journeys, Assumptions & Constraints, Next Steps

---

## Tips

- **Link to a project** whenever possible — It gives avatars access to research, documents, and prior session insights
- **Use Default Avatars for your first session** — They cover a good range of perspectives
- **Write specific goals** — "Identify top 3 pain points for enterprise customers" is better than "Discuss the product"
- **Preview templates** before selecting — Check that the phases match your agenda`;
